const users = [
    { 
        username: process.env.REACT_APP_GOD_USERNAME, 
        password: process.env.REACT_APP_GOD_PASSWORD, 
        role: 'god' 
    },
    { 
        username: process.env.REACT_APP_DRIVER1_USERNAME, 
        password: process.env.REACT_APP_DRIVER1_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER1_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER1_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER2_USERNAME, 
        password: process.env.REACT_APP_DRIVER2_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER2_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER2_LABOR_COST, 10) || 0, 
        pointRate: parseInt(process.env.REACT_APP_DRIVER2_POINT_RATE, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER3_USERNAME, 
        password: process.env.REACT_APP_DRIVER3_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER3_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER3_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER4_USERNAME, 
        password: process.env.REACT_APP_DRIVER4_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER4_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER4_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER5_USERNAME, 
        password: process.env.REACT_APP_DRIVER5_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER5_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER5_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER6_USERNAME, 
        password: process.env.REACT_APP_DRIVER6_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER6_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER6_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER7_USERNAME, 
        password: process.env.REACT_APP_DRIVER7_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER7_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER7_LABOR_COST, 10) || 0, 
        pointRate: parseInt(process.env.REACT_APP_DRIVER7_POINT_RATE, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER8_USERNAME, 
        password: process.env.REACT_APP_DRIVER8_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER8_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER8_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER9_USERNAME, 
        password: process.env.REACT_APP_DRIVER9_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER9_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER9_LABOR_COST, 10) || 0 
    },
    { 
        username: process.env.REACT_APP_DRIVER10_USERNAME, 
        password: process.env.REACT_APP_DRIVER10_PASSWORD, 
        role: 'คนรถ', 
        carNumber: parseInt(process.env.REACT_APP_DRIVER10_CAR_NUMBER, 10) || 0, 
        laborCost: parseInt(process.env.REACT_APP_DRIVER10_LABOR_COST, 10) || 0 
    }
];

export { users };
